


















































































































































import axios from 'axios';
import { find, filter, map, get, cloneDeep } from 'lodash';
import CoEmojiPicker from '../co-emoji-picker/CoEmojiPicker.vue';
import EventBus from '../../../eventBus';
import CoTippy from '../../Atoms/co-tippy/CoTippy.vue';

// The realtime API can retain an emoji key after its last user removes it; those are not displayable reactions.
const getActiveReactions = (reactions) =>
    Object.keys(reactions || {}).reduce((activeReactions, emoji) => {
        if (Array.isArray(reactions[emoji]?.Users) && reactions[emoji].Users.length > 0) {
            return { ...activeReactions, [emoji]: cloneDeep(reactions[emoji]) };
        }
        return activeReactions;
    }, {});

export default {
    components: { CoEmojiPicker, CoTippy },
    name: 'CoReactions',
    props: {
        reactions: {
            type: Object,
            default() {
                return {};
            },
        },
        objectID: {
            type: String,
            required: true,
        },
        objectType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            me: get(this, '$store.state.me') ? this.$store.state.me : {},
            localReactions: getActiveReactions(this.reactions),
        };
    },
    computed: {
        uid() {
            return this._uid;
        },
    },
    watch: {
        reactions: {
            handler(nextReactions) {
                this.localReactions = getActiveReactions(nextReactions);
            },
            deep: true,
        },
    },
    methods: {
        addReactionToLocal(emoji) {
            if (this.localReactions && this.localReactions[emoji] && this.localReactions[emoji].Users) {
                this.localReactions[emoji].Users.push(this.me);
            } else {
                this.$set(this.localReactions, emoji, { Users: [this.me] });
            }
        },
        removeReactionFromLocal(emoji) {
            if (this.localReactions && this.localReactions[emoji] && this.localReactions[emoji].Users) {
                this.localReactions[emoji].Users = filter(this.localReactions[emoji].Users, (o) => o.ID != this.me.ID);
                if (this.localReactions[emoji].Users.length === 0) this.$delete(this.localReactions, emoji);
            }
        },
        reactionHandler(emoji) {
            if (this.localReactions && this.localReactions[emoji] && this.localReactions[emoji].Users) {
                // reaction type already exists
                if (find(this.localReactions[emoji].Users, { ID: this.me.ID })) {
                    this.removeReaction(emoji);
                } else {
                    this.addReaction(emoji);
                }
            } else {
                // define base reaction object and add the reaction as this is the first time the reaction type is being added
                this.$set(this.localReactions, emoji, { Users: [] });
                // reaction type does not exists
                this.addReaction(emoji);
            }
        },
        addReaction(emoji) {
            this.addReactionToLocal(emoji);
            axios({
                method: 'POST',
                url: '/reactions',
                data: {
                    Emoji: emoji,
                    ObjectID: this.objectID,
                    ObjectType: this.objectType,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$emit('reacted', { emoji });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: 'Failed to save the reaction',
                        Details: error,
                    });
                });
        },
        removeReaction(emoji) {
            this.removeReactionFromLocal(emoji);
            axios({
                method: 'DELETE',
                url: '/reactions',
                data: {
                    Emoji: emoji,
                    ObjectID: this.objectID,
                    ObjectType: this.objectType,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {})
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: 'Failed to save the reaction',
                        Details: error,
                    });
                });
        },
        byMe(users) {
            return find(users, { ID: this.me.ID }) ? true : false;
        },
        getUserNames(users) {
            return map(users, (value) =>
                value && value.ID === this.me.ID ? this.$t('labels.you') : get(value, 'Name')
            );
        },
    },
};
